const version = "7.16.1";
export {
  version
};
//# sourceMappingURL=package.json.js.map
